module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note"
  }, [_c('h2', {
    staticClass: "note__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (!_vm.note) ? _c('PulseLoader', {
    staticClass: "loading-indicator"
  }) : _vm._e(), _vm._v(" "), (_vm.note) ? _c('form', {
    staticClass: "note__form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveNote($event)
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.text),
      expression: "note.text"
    }],
    staticClass: "note__editor",
    domProps: {
      "value": (_vm.note.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "note__bar"
  }, [_c('span', {
    staticClass: "note__message",
    class: _vm.message.type
  }, [_vm._v(_vm._s(_vm.message.text))]), _vm._v(" "), _c('input', {
    staticClass: "note__submit pure-button",
    attrs: {
      "type": "submit",
      "value": "Save"
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a9aefa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Note.vue
// module id = 117
// module chunks = 1